var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paper',{staticClass:"color-block",style:(_vm.styles)},[_c('RatioBox',{attrs:{"ratio":1}},[_c('span',{staticClass:"color-block__text"},[_vm._v(_vm._s(_vm.color))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }